import { useMemo, useState } from 'react';

export type VisitorEmailConflictType = 'host' | 'submitter';

type Params = {
  email: string;
  submitterEmail?: string;
  hostEmail?: string;
};

type Result = {
  hasConflict: boolean;
  conflictType: VisitorEmailConflictType | null;
  onEmailBlur: () => void;
};

function normalize(email: string): string {
  return email.trim().toLowerCase();
}

function matches(email: string, otherEmail?: string): boolean {
  return Boolean(otherEmail) && normalize(email) === normalize(otherEmail!);
}

export function useVisitorEmailConflictValidation({
  email,
  submitterEmail,
  hostEmail,
}: Params): Result {
  const [touched, setTouched] = useState(false);

  const conflictType = useMemo<VisitorEmailConflictType | null>(() => {
    if (!touched || !email) return null;

    if (matches(email, hostEmail)) return 'host';

    if (matches(email, submitterEmail)) return 'submitter';

    return null;
  }, [touched, email, submitterEmail, hostEmail]);

  return {
    hasConflict: conflictType !== null,
    conflictType,
    onEmailBlur: () => setTouched(true),
  };
}
